import React from "react";
import { Modal } from "../../design-system";
import { colors } from "../../design-system/colors";

interface OnboardingModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const OnboardingModal: React.FC<OnboardingModalProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth={false}
      keepMounted
      PaperProps={{ sx: { "& > div": { background: colors.modal.background } } }}
    >
      {children}
    </Modal>
  );
};

export default OnboardingModal;
